import { ReactNode } from 'react';
import { useDndContext, useDroppable } from '@dnd-kit/core';
import { Container } from './index.styles';
import { DRAGGABLE_STATUSES } from '../../../../utils';

interface Props {
  children: ReactNode;
  dayKey: string;
  isToday: boolean;
  view: CalendarView;
}

export const DroppableDay = ({ dayKey, isToday, children, view }: Props) => {
  const { active } = useDndContext();
  const activeStatus: string | undefined = active?.data?.current?.message?.status;
  const canAcceptActive = !!active && !!activeStatus && DRAGGABLE_STATUSES.includes(activeStatus);
  const disabled = !canAcceptActive;

  const { setNodeRef, isOver } = useDroppable({
    id: dayKey,
    data: {
      disabled,
      dayKey,
      canAcceptActive,
    },
  });

  const highlight = !disabled && isOver;

  return (
    <Container
      ref={setNodeRef}
      $isToday={isToday}
      $isOver={highlight}
      $view={view}
    >
      {children}
    </Container>
  );
};
